// extracted by mini-css-extract-plugin
export default {"button":"RoundedButton_button__jZfuo"};